// SpreadsheetIcon.jsx

import React from 'react';

/**
 * SpreadsheetIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const SpreadsheetIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 14.5,7.9999999 c -1.385,0 -2.5,1.115 -2.5,2.5000001 v 45 c 0,1.385 1.115,2.5 2.5,2.5 h 35 C 50.885,58 52,56.885 52,55.5 V 23 L 38.25,21.75 37,7.9999999 Z"
    />
    <path fill="#4bae4f" d="m14.5 7c-1.385 0-2.5 1.115-2.5 2.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5v-32.5l-13.75-1.25-1.25-13.75z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="M 37,7.9999999 V 20.5 c 0,1.3808 1.1193,2.5 2.5,2.5 H 52 Z"
    />
    <path fill="#95cd97" d="m37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5h12.5l-15-15z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="M 20,32 V 50 H 43 V 32 Z m 3,3 h 7 v 2 h -7 z m 10,0 h 7 v 2 h -7 z m -10,5 h 7 v 2 h -7 z m 10,0 h 7 v 2 h -7 z m -10,5 h 7 v 2 h -7 z m 10,0 h 7 v 2 h -7 z"
    />
    <path fill="#fff" d="m20 31v18h23v-18zm3 3h7v2h-7zm10 0h7v2h-7zm-10 5h7v2h-7zm10 0h7v2h-7zm-10 5h7v2h-7zm10 0h7v2h-7z" />
    <path
      style={{
        fill: '#ffffff',
        opacity: 0.1,
      }}
      d="m 14.5,6.9999999 c -1.385,0 -2.5,1.115 -2.5,2.5 V 10.5 C 12,9.1149999 13.115,7.9999999 14.5,7.9999999 H 37 c 0,-1 0,0 0,-1 z"
    />
  </svg>
  );
});

// Dev Tools
SpreadsheetIcon.displayName = 'SpreadsheetIcon';

export default SpreadsheetIcon;
